import { fetchFeatureSnapshots } from 'services/feature/snapshots'

import { apiAction } from 'actions/application.js'
import { createAction } from 'actions/utils'

import { featureSnapshotsSchema } from 'schemas/feature'

export const FEATURE_SNAPSHOTS_RECEIVED = 'FEATURE_SNAPSHOTS_RECEIVED'
export const FEATURE_SNAPSHOTS_FAILED = 'FEATURE_SNAPSHOTS_FAILED'

export const getFeatureSnapshots = (featureId) =>
  apiAction({
    asyncFn: fetchFeatureSnapshots,
    args: { featureId },
    successActionType: FEATURE_SNAPSHOTS_RECEIVED,
    failureActionType: FEATURE_SNAPSHOTS_FAILED,
    id: featureId,
    schema: featureSnapshotsSchema,
  })

export const SET_FEATURE_SNAPSHOT = 'SET_FEATURE_SNAPSHOT'
export const setFeatureSnapshot = createAction(SET_FEATURE_SNAPSHOT, ['uri'])
